import Button from './Button';
import * as React from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';
import * as CloseIcon from 'react-icons/lib/io/close-round';
import * as VideoIcon from 'react-icons/lib/io/ios-videocam';
import colors from '../colors';
import { Banner as BannerT, User } from '../../typedefs/store';

interface Props {
    acceptVideoRequest: () => void;
    agent: User;
    webRtcSupported: boolean;
}
interface State {}

class VideoRequest extends React.Component<Props, State> {
    render() {
        if (!this.props.webRtcSupported) {
            return (
                <Wrapper className="conversations-message-item conversations-message-video-request conversations-message-video-request-error">
                    <VideoIcon size={80} style={{ marginRight: 20 }} />
                    <MessageWrapper>
                        {this.props.agent.firstName} {this.props.agent.lastName} has requested a
                        live video, but your web browser does not support live video.
                    </MessageWrapper>
                </Wrapper>
            );
        }

        return (
            <Wrapper className="conversations-message-item conversations-message-video-request">
                <MessageWrapper className="conversations-message-video-text">
                    {this.props.agent.firstName} {this.props.agent.lastName} has requested a live video!
                </MessageWrapper>
                <Button
                    backgroundColor={colors.green}
                    className="conversations-message-video-request-accept"
                    onClick={this.props.acceptVideoRequest}
                    primary={true}
                >
                    <VideoIcon size={18} style={{ marginRight: 5 }} /> Start
                </Button>
            </Wrapper>
        );
    }
}

export default VideoRequest;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 2em 0 1em 0;
`;
const MessageWrapper = styled.div`
    margin-right: 1em;
    font-size: 14px;
    font-weight: 400;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/VideoRequest.tsx